import { Link } from "@mui/material";
import React from "react";
import { useAppIdMap } from "../../hook/app";
import { ListItemSmall, ListItemTextSmall } from "./listItem";

export const SideNavMarketplace: React.FC = () => {
  const { appId } = useAppIdMap();

  return (
    <Link href={`/marketplace`}>
      <ListItemSmall sx={{ pl: 2 }}>
        <ListItemTextSmall>Install Components</ListItemTextSmall>
      </ListItemSmall>
    </Link>
  );
};
